export default __webpack_public_path__ + "static/media/services-icon.da8f6f56.svg";